var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVkDesktopHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 14,
  viewBox: "0 0 17 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8.025 3.218c-.6-3.5-4.8-4-6.6-2.2-1.9 1.9-1.9 4.8 0 6.7.5.5 5.5 5.3 5.5 5.3.5.6 1.6.6 2.1 0l5.5-5.3c2-1.9 2-4.8.1-6.7-1.8-1.7-6-1.3-6.6 2.2"
})));
export default SvgVkDesktopHeart;